<template>
<div class="c-footer" :class="[`c-footer--${currentPoloID}`, {'c-footer--show': $store.getters.isShowFoot}]">
  <small>Copyright © TSI Inc. All Rights Reserved.</small>
  <ul class="is-btns">
    <li>
      <button class="c-btn2" @click="gotoTop">
        <span class="is-text">PAGE TOP</span>
        <span class="is-arrow"></span>
      </button>
    </li>
    <li>
      <a class="c-btn1" href="https://store.tsigs.com/PEARLYGATES/pg-topics/pg-jb_10_colors/" target="_blank">
        <span>BUY</span>
      </a>
    </li>
  </ul>
</div>
</template>

<script>
import { gsap } from 'gsap/gsap-core';

export default {
  data() {
    return {
    }
  },
  computed: {
    currentPoloID() {
      return this.$store.getters.currentPoloID;
    },
  },
  mounted() {
  },
  methods: {
    gotoTop() {
      this.$store.commit('setShowPolo', false);
    },
  }
}
</script>